import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=12f6fa1e"
import script from "./coupon.ts?vue&type=script&lang=js&external"
export * from "./coupon.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports